import { ActionFunction } from "react-router";
import { Outlet } from "react-router";
import { GenericBoundary } from "~/components/error-boundaries/error-boundaries";

export const ErrorBoundary = GenericBoundary;

export const action: ActionFunction = async ({ request }) => {
  const formData = await request.formData();
  const appUrl = process.env.INTERNAL_APP_URL as string; // How does this evne work?!

  const headers = {} as any;
  request.headers.forEach((v, k) => (headers[k] = v));

  const newFormData = new FormData();
  newFormData.set("email", formData.get("email") || "");
  newFormData.set(
    "mixpanel_distinct_id",
    formData.get("mixpanel_distinct_id") || "",
  );

  // The below line is actually valid. This is the way to transform formData properly, but somehow it seems like
  // typescript doesn't like it.
  // @ts-ignore
  const asString = new URLSearchParams(newFormData).toString();

  const res = await fetch(`${appUrl}/api/easySignup`, {
    method: "POST",
    body: asString,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    redirect: "manual",
  });

  // The response is always a 302. So, we'll consider valid if the cookies are set
  if (res.headers.has("set-cookie")) {
    const headers = new Headers();
    const cookies = res.headers.get("set-cookie");
    if (!cookies) {
      return { error: "no cookie" };
    }
    cookies.split(",").forEach((cookie) => {
      headers.append("Set-Cookie", cookie);
    });
    headers.append("location", res.headers.get("location") || "/onboarding");
    return new Response("ok", {
      status: 302,
      headers,
    });
  }

  console.error(res.status, res.headers, res, await res.text());
  //TODO: improve error manage. `Is it because they already exist?`.
  return { error: "response failed" };
};

export default function Index() {
  return <Outlet />;
}
